import React from 'react'
import styled from 'styled-components'
import { getAgeLabelOnPrice, IAges, IPriceBreakdownData } from 'utils/reservation'
import { utilService } from 'core/services'
import * as constants from '../../../../../static/constants'

interface IProps {
  label: 'Adults' | 'Children' | 'Infants' | 'Guests'
  ages?: IAges
  priceData: IPriceBreakdownData | null
  isGroup?: boolean
}

export const PriceBreakdown = ({ label, ages, priceData, isGroup }: IProps) => {
  const ageLabel = getAgeLabelOnPrice(label, ages)

  return (
    <PriceBreakDownWrapper>
      <div>
        <span>{label}</span>
        {ages && label !== 'Guests' && <span> {ageLabel}</span>}
        <span className="bold">{priceData?.count ?? '0'}</span>
        {isGroup && (
          <>
            <span>×</span>
            <span>{utilService.formatPrice(priceData?.price ?? null)}</span>
          </>
        )}
      </div>
      {isGroup && <span>{utilService.formatPrice(priceData?.calcPrice ?? null)}</span>}
    </PriceBreakDownWrapper>
  )
}

const PriceBreakDownWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.4rem;
  @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
    font-size: 1.4rem;
  }

  .bold {
    font-weight: bold;
  }
`
